import React, { useContext, useEffect, useState } from 'react';
import './BookingPage.css';
import {
  DateCalendar,
  LocalizationProvider,
  PickersDay,
} from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { format, parseISO } from 'date-fns';
import ru from 'date-fns/locale/ru';
import { JourneyContext } from '../../Contexts/JourneyContext';
import Booking from './Booking';
import  Selector from '../App/Common/Inputs/Selector/Selector';
import defaultAvatar from '../../Media/Avatar.svg'

import { useCookies } from 'react-cookie';

import api from '../../Utils/Api';
import Calendar from '../Calendar/Calendar';

function ServerDay(props) {
  const { highlightedDays = [], day, outsideCurrentMonth, ...other } = props;
  // console.log(day);
  const isoDate = format(day, 'yyyy-MM-dd');

  // console.log(highlightedDays);
  
  const isSelected =
    !outsideCurrentMonth &&
    highlightedDays.length > 0 &&
    highlightedDays.some((h) => h.date === isoDate);

  return (
    <PickersDay
      {...other}
      outsideCurrentMonth={outsideCurrentMonth}
      day={day}
      sx={{
        background:'white',
        fontWeight: isSelected ? 'bold' : 400,
      }}
    />
  );
}

function BookingPage() {
  const { setCurrentPlace } = useContext(JourneyContext);
  const [courses, setCourses] = useState([]);
  const [currentCourse, setCurrentCourse] = useState(null);
  const [slots, setSlots] = useState([]);
  const [slot, setSlot] = useState([]);
  const [currentSlot, setCurrentSlot] = useState([])
  const [currentTeacher, setCurrentTeacher] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [comment, setComment] = useState('')
  const [highlightedDays, setHighlightedDays] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const [cookies, setCookie, removeCookie] = useCookies(['token']);
  const [token, setToken] = useState(cookies.token ? cookies.token : undefined);
  const [course, setCourse] = useState([])
  const [image, setImage] = useState()

  const today = new Date();
  const formattedDate = format(today, 'PPPP', { locale: ru });
  const dateTitle = formattedDate.split(', ')[1].replace(/\d+ г\.$/, '');

  // console.log(dateTitle);

  useEffect(() => {
    // setCurrentPlace( {title: 'Актуальные задания'})
    api
      .getCoursesTeacher(token)
      .then((res) => {
        setCourses(res);
      })
      .catch((e) => {
        // console.log(e);
      });
    setCurrentPlace({ title: 'Онлайн-запись' });
    setHighlightedDays(slots);
    api.getCourses(token).then((res) => {
      console.log(res)
      setCourse(res)
    })
  }, []);

  useEffect(() => {
    setHighlightedDays([]);
  }, [currentCourse])

  function handleCourse(e) {
    setCurrentCourse(e);
    // если когда-нибудь будет больше чем один учитель
    setCurrentTeacher([e]);
    fetchTeachersData(e)
    fetchCoursesData(e)
  }

  function handleDate(e) {
    fetchSlot(e);
    setSelectedDate(e.teacher_id);
  }

  function fetchTeachersData(e) {
    // console.log(e.id);
    api.getTeachersData(token, e.teacher_id, e.id).then((res) => {
      console.log(res);
      setSlots(res.slots)
      setHighlightedDays(res.slots)
    })
  }

  function fetchCoursesData(e) {
    // api.getRoadMap(token, e.id).then((res) => {
    //   console.log(res);
    //   setCourse(res.image)
    // })
    const image = course.filter((el) => el.id === e.id)
    console.log(image)
    setImage(image[0].image)
  }

  function fetchSlot(date) {

    const dateIs = new Date(date).toLocaleDateString('en-US', {
      timeZone: 'Europe/Moscow',
    });
    const [month, day, year] = dateIs.split('/');
    const isoDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    const slot = slots.filter((s) => s.date === isoDate);
    setSlot(slot);
  }

  function toggleModal(e) {
    setIsVisible(!isVisible);
    setCurrentSlot(slots.find((s) => s.id === e));
  }

  function createRequest(e) {
    console.log(e);
    api.createBookingRequest(token, currentSlot.id, comment, currentCourse.title, currentCourse.teacher_name).then((res) => {
      console.log(res);
      setIsVisible(false)
    })
  }

  const [tab, setTab] = useState(false)
  const [titleTag, setTitle] = useState('')


  const handleOpenTab = (title) => {
    if (title === 'Календарь') {
         setTab(true)
         setTitle('_calendar') 
     } else if (title === 'Мои заявки') {
       setTitle('_request')
       setTab(false)
     } else if (title === 'Запись') {
      setTitle('_online')
      setTab(false)
    }
   } 

  const maxLength = 300; 

  return (
    <div className="booking-page">
      <div className="booking-page__body_wrap">
        <Booking tab={tab} handleOpenTab={handleOpenTab} titleTag={titleTag}/>
        <div className='tab__wrap'>
        {/* <div className={'tab__btn' + (titleTag ? titleTag === '_calendar' : 'false')} onClick={() => handleOpenTab('Календарь')}>Календарь</div> */}
        
        </div>
        {tab && <div className='courses__calendar'><Calendar></Calendar></div>}

       {!tab && <div className="booking-page__body">
          <div className="booking-page__teacher-profile">
            <div className="booking-page__select-btn">
              <Selector
                // title={
                //   currentCourse !== null ? currentCourse.title : 'Выберите курс'
                // }
                placeholder={"Выберите курс"}          
                groups={courses}
                selectedItem={currentCourse}
                onChangeAction={(e) => {
                  handleCourse(e);
                }}
              ></Selector>
              {currentTeacher.length !== 0 ? (
                currentTeacher.map((teacher) => (
                  <div className="teacher-profile">
                    <div className='booking__courseImg'>
                      <img src={image}></img>
                    </div>
                    {/* <div className="teacher-name">
                      <p>{teacher.teacher_name}</p>
                    </div>
                    <p></p> */}
                    {/* <div className="teacher-description">
                      <span>Здесь вы можете выбрать мои свободные слоты</span>
                    </div> */}
                    <div className='teacher__choice'>
                    <div className="teacher-avatar">
                      {/* Фото учителя */}
                      <img src={teacher.avatar ? teacher.avatar : defaultAvatar} />
                     {/* {teacher?.avatar === null ? ( <img src="../../Media/DefaultAvatar.svg" />) : ( <img src="" />)} */}
                    </div>
                    <Selector
                // title={
                //   currentCourse !== null ? currentCourse.title : 'Выберите курс'
                // }
                placeholder={teacher.teacher_name? teacher.teacher_name : "Выберите учителя"}          
                groups={[{title: teacher.teacher_name}]}
                selectedItem={{title: teacher.teacher_name}}
                onChangeAction={(e) => {
                  // handleCourse(e);
                }}
                user={teacher.avatar ? teacher.avatar : defaultAvatar}
              ></Selector>
              </div>
                  </div>
                ))
              ) : (
                <div className="teacher-profile inActive">
                  <span className="teacher-description">
                    Выберите курс для возможности выбора слота
                  </span>
                </div>
              )}
            </div>
          </div>
          <div className='booking-page__slotsWrap'>
          <div className="booking-page__calendar">
            <LocalizationProvider
              dateAdapter={AdapterDateFns}
              adapterLocale={ru}
            >
              <DateCalendar
                className="date-calendar"
                selected={selectedDate}
                showDaysOutsideCurrentMonth
                fixedWeekNumber={6}
                //   referenceDate={dayjs('2022-04-17')}
                onChange={(e) => handleDate(e)}
                views={['year', 'month', 'day']}
                style={{borderRadius: '15px'}}
                sx={{
                  '.MuiDateCalendar-root': {
                    borderRadius: '15px',
                  },
                  '.MuiPickersDay-root': {
                    fontSize: '15px',
                    borderRadius: '20%',
                    fontFamily: 'Montserrat',
                  },
                  '.MuiTypography-root': {
                    fontSize: '15px',
                    fontFamily: 'Montserrat',
                    fontWeight: '700'
                  },
                  'MuiPickersCalendarHeader-labelContainer': {
                    fontFamily: 'Montserrat',
                    whiteSpace: 'nowrap'
                  },
                  'MuiPickersCalendarHeader-label': {
                    whiteSpace: 'nowrap'
                  },
                  '.MuiPickersDay-root.Mui-selected': {
                    background: '#7A5AF8',
                  },
                  '.MuiPickersDay-root:focus.Mui-selected': {
                    background: '#7A5AF8',
                  },
                  '.MuiPickersArrowSwitcher-root': {
                    gap: '30px',
                  }
                }}
                slots={{
                  day: ServerDay,
                }}
                slotProps={{
                  day: {
                    highlightedDays,
                  },
                }}
              />
            </LocalizationProvider>
          </div>
          <div className="booking-page__calendar-slots">
            <div className="calendar-slots_text">
              <p>Свободные слоты</p>
              {slot.length !== 0 ? (
                <span>{`${format(parseISO(slot[0]?.date), 'dd MMMM', { locale: ru })}`}</span>
              ) : (
                <span>{dateTitle}</span>
              )}
            </div>
            {slot && slot.length !== 0 ? (
              <>
                <div className="booking-page__calendar_slots">
                  {slot.map((s) => (
                    <>
                      <div key={s.id}
                        className="slot"
                        onClick={(e) => toggleModal(s.id)}
                      >
                        {/* {`${s.date} ${s.start_time.slice(0, -3)} - ${s.end_time.slice(0, -3)}`} */}
                        {`${format(parseISO(s.date), 'dd MMMM', { locale: ru })} ${s.start_time.slice(0, -3)} - ${s.end_time.slice(0, -3)}`}
                      </div>
                      {isVisible && currentSlot  && (
                        <div className="booking-page__comment">
                          <div>
                            <div>Вы выбрали слот</div>
                            <div className="slot">{`${format(parseISO(currentSlot.date), 'dd MMMM', { locale: ru })} ${currentSlot.start_time.slice(0, -3)} - ${currentSlot.end_time.slice(0, -3)}`}</div>
                            <label for="comment">Комментарий</label>
                            <textarea 
                            style={{padding: '20px', resize: 'none'}} 
                            name="comment" id="comment" 
                            onChange={(e) => setComment(e.target.value)}
                            maxLength={maxLength}
                            ></textarea>
                            <button
                              // type="submit"
                              buttonText={'Отправить'}
                              color="#22C532"
                              onClick={(e) => createRequest(s)}
                            >
                              Отправить
                            </button>
                            <div className='comment__counter'>
                              <span>{`${maxLength - comment.length} символов осталось`}</span>
                            </div>
                            <div
                              className="popup__closeBtn"
                              onClick={toggleModal}
                              buttonText={'Закрыть'}
                            ></div>
                          </div>
                        </div>
                      )}
                    </>
                  ))}
                </div>
              </>
            ) : (
              <div className="booking-page__calendar_text">
                <span>Выберите дату, чтобы увидеть доступные слоты</span>
              </div>
            )}
          </div>
          </div>
        </div>}
      </div>
    </div>
  );
}

export default BookingPage;
